var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { Form, Field } from 'react-redux-form';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';
import rison from 'rison-node';
import { Icon } from "../../UI";
import { t } from "../../I18N";
import ModalTips from "../../App/ModalTips";
import { SearchTipsContent } from "../../App/SearchTipsContent";

const SearchBox = ({ placeholder, classname }) => {
  const navigate = useNavigate();

  const search = ({ searchTerm }) => {
    navigate(`/library/?q=${rison.encode({ searchTerm })}`);
  };

  return (/*#__PURE__*/
    _jsx("div", { className: `search-box ${classname}` }, void 0, /*#__PURE__*/
    _jsx(Form, { model: "library.search", onSubmit: search }, void 0, /*#__PURE__*/
    _jsx("div", { className: "input-group" }, void 0, /*#__PURE__*/
    _jsx("button", { type: "submit", className: "btn btn-primary" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "search" })
    ), /*#__PURE__*/
    _jsx(Field, { model: ".searchTerm" }, void 0, /*#__PURE__*/
    _jsx("input", { className: "form-control", type: "text", placeholder: placeholder })
    )
    )
    ), /*#__PURE__*/
    _jsx(ModalTips, {
      label: t('System', 'Search Tips', null, false),
      title: t('System', 'Narrow down your searches', null, false) }, void 0, /*#__PURE__*/

    _jsx(SearchTipsContent, {})
    )
    ));

};
SearchBox.defaultProps = {
  placeholder: '',
  classname: ''
};






export default SearchBox;